/** The Enum Verb. */
export enum Verb {
  ADD= "ADD",
  DELETE = "DEL",
  UPDATE = "UPD"
}
